import httpClient from '../httpClient';
import { AxiosRequestConfig } from 'axios';
import { SponsoredAdvert } from 'models/SponsoredAdvert';
import { UploadedFileResponse } from 'models/File';
import { PaginatedData } from 'models/PaginatedData';
import { getFileParams, getUploadedFile } from 'uploadFileUtils';

function getSponsoredAdvertPublic() {
  return httpClient.get<{
    sponsoredListingStripAd: SponsoredAdvert;
    sponsoredListingMedRec: SponsoredAdvert;
  }>(`sponsored-listings/business-page`);
}

function deleteSponsoredAdvert(advertId: string) {
  return httpClient.delete(`sponsored-listings/${advertId}`);
}

async function uploadSponsoredAdvertImage(
  file: File,
  fileName: string,
  advertId: string,
  config: AxiosRequestConfig,
  customName?: string,
) {
  const fileParams = getFileParams(fileName, file, customName);

  const { data } = await httpClient.post<UploadedFileResponse>(
    `sponsored-listings/${advertId}/upload-temporary-object`,
    fileParams,
  );

  return await getUploadedFile(data, file, config);
}

function deleteSponsoredAdvertImage(
  advertId: string,
  fileName: string,
  fileId: string,
) {
  return httpClient.delete<{
    fileId: string;
    sponsoredListing: SponsoredAdvert;
  }>(`sponsored-listings/${advertId}/files/${fileName}/${fileId}`);
}

function getSponsoredAdverts(params?: Record<string, any>) {
  return httpClient.get<PaginatedData<SponsoredAdvert>>(`sponsored-listings`, {
    params,
  });
}

function patchSponsoredAdvert(
  advertId: string,
  patchedValues: Partial<SponsoredAdvert>,
) {
  return httpClient.patch<SponsoredAdvert>(
    `sponsored-listings/${advertId}`,
    patchedValues,
  );
}

function getLatestDraft() {
  return httpClient.post(`sponsored-listings`);
}

function pauseSponsoredAdvert(advertId: string) {
  return httpClient.post(`sponsored-listings/${advertId}/pause`);
}

function unpauseSponsoredAdvert(advertId: string) {
  return httpClient.post(`sponsored-listings/${advertId}/unpause`);
}

export default {
  getLatestDraft,
  getSponsoredAdverts,
  uploadSponsoredAdvertImage,
  deleteSponsoredAdvertImage,
  patchSponsoredAdvert,
  pauseSponsoredAdvert,
  unpauseSponsoredAdvert,
  deleteSponsoredAdvert,
  getSponsoredAdvertPublic,
};
